import {AddonGroupResponse} from "libs/shared-models/src/lib/restaurant/addon-group-response";

export class AddonGroupListResponse {
  addonGroupList: AddonGroupResponse[] = [];
}
